import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Image, Video, Music, FileText, QrCode, BarChart3 } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { MediaNodeData } from '../../types/nodes';

const mediaIcons = {
  image_editor: <Image />,
  video_processor: <Video />,
  audio_generator: <Music />,
  document_creator: <FileText />,
  qr_generator: <QrCode />,
  chart_builder: <BarChart3 />
};

const mediaLabels = {
  image_editor: 'Editor Immagini',
  video_processor: 'Processore Video',
  audio_generator: 'Generatore Audio',
  document_creator: 'Creatore Documenti',
  qr_generator: 'Generatore QR',
  chart_builder: 'Costruttore Grafici'
};

const MediaNode: React.FC<NodeProps<MediaNodeData>> = memo(({ selected, data }) => {
  const icon = mediaIcons[data.mediaType] || <Image />;
  const label = mediaLabels[data.mediaType] || 'Media';
  
  const getPreview = () => {
    switch (data.mediaType) {
      case 'image_editor':
        return data.config.imageEffects?.join(', ') || 'Nessun effetto';
      case 'video_processor':
        return data.config.videoTrim ? `Trim: ${data.config.videoTrim.start}s - ${data.config.videoTrim.end}s` : 'Video completo';
      case 'audio_generator':
        return data.config.audioVoice || 'Voce predefinita';
      case 'document_creator':
        return data.config.documentTemplate || 'Template vuoto';
      case 'qr_generator':
        return data.config.qrData ? 'QR configurato' : 'QR vuoto';
      case 'chart_builder':
        return data.config.chartType || 'Grafico a barre';
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-purple-500 to-pink-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

MediaNode.displayName = 'MediaNode';

export default MediaNode;
